import { donationConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'donations';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	donations: [],
	donationsById: {},
	allDonationesByRecipientId: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit donations
		case donationConstants.SAVING_DONATION_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case donationConstants.SAVING_DONATION_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case donationConstants.SAVING_DONATION_FAILURE:	
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete donation
		case donationConstants.DELETE_DONATION_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case donationConstants.DELETE_DONATION_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case donationConstants.DELETE_DONATION_FAILURE:	
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load donations
		case donationConstants.LOAD_DONATION_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case donationConstants.LOAD_DONATION_SUCCESS:
			const params = createParams({ name, state, data: data.data });
			const recipientId = data.data[0] ? data.data[0].recipient_id : null;
			const allDonationesByRecipientId = recipientId ? {...state.allDonationesByRecipientId, [recipientId]: params.donations} : state.allDonationesByRecipientId;
			return {
				...params,
				allDonationesByRecipientId,
				allLoading: state.allLoading - 1
			};
		case donationConstants.LOAD_DONATION_FAILURE:	
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/donation.reducers.js